import { action, makeObservable, observable } from 'mobx';
import { FormField } from './formField';
import { RootStore } from './root';
import { ROUTES } from '../routes';
import { DEVICE_LOGIN_METHODS, WIX_HOME_URL } from '../utils/constants';

export class Web5DeviceLoginStore {
  private readonly rootStore: RootStore;
  private readonly authHandlers: {
    CONNECTION_SUCCESSFUL: () => void;
  };
  public code: FormField;
  public isLoading = false;
  private VERIFY_CODE_INTERACTION_NAME = 'verify-code';
  public codeLength = 8;
  private urlParams: URLSearchParams = new URLSearchParams(
    window.location.search,
  );
  private isDebug: boolean =
    this.urlParams.get('debugCase') === 'web5DeviceLogin';

  get contentKey(): string {
    return 'web5Device.login.connect.currently.logged.in';
  }

  get currentLoggedInEmail(): string {
    const userDataLoggedInEmail =
      this.rootStore.userDataStore.currentLoggedInEmail;
    if (userDataLoggedInEmail) {
      return userDataLoggedInEmail;
    } else {
      return this.isDebug ? this.urlParams.get('email') ?? '' : '';
    }
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    const {
      navigationStore: { curryNavigate: navigate },
    } = rootStore;
    makeObservable(this, {
      submit: action.bound,
      code: observable,
      isLoading: observable,
    });

    this.code = new FormField('');

    this.authHandlers = {
      [DEVICE_LOGIN_METHODS.CONNECTION_SUCCESSFUL]: navigate(
        ROUTES.WEB5_DEVICE_CONNECTION_SUCCESSFUL,
      ),
    };
  }

  public enableAccess(): boolean {
    return !!this.rootStore.userDataStore.currentLoggedInEmail || this.isDebug;
  }

  public redirectToWix() {
    return this.rootStore.navigationStore.redirect(WIX_HOME_URL);
  }

  public async submit() {
    if (!this.code.isValid) {
      return;
    }
    if (this.code.value.length < 8 || this.code.value.length > 8) {
      this.code.addError(
        this.rootStore.i18n.t(
          'web5Device.login.code.input.code.length.errorInfo',
        ),
      );
      return;
    }

    this.rootStore.panorama.startTransaction(this.VERIFY_CODE_INTERACTION_NAME);
    const code = this.code.value;
    const { apiStore } = this.rootStore;
    this.isLoading = true;
    try {
      const verifyCode = await apiStore.deviceVerifyCode(code);

      if (verifyCode === 200) {
        this.authHandlers[DEVICE_LOGIN_METHODS.CONNECTION_SUCCESSFUL]();
      } else {
        this.code.addError(
          this.rootStore.i18n.t(
            'web5Device.login.code.input.incorrect.errorInfo',
          ),
        );
      }
      this.rootStore.panorama.finishTransaction(
        this.VERIFY_CODE_INTERACTION_NAME,
      );
    } catch (error: any) {
      this.rootStore.panorama.finishTransaction(
        this.VERIFY_CODE_INTERACTION_NAME,
      );
      this.code.addError(
        this.rootStore.i18n.t(
          'web5Device.login.code.input.incorrect.errorInfo',
        ),
      );
    } finally {
      this.isLoading = false;
    }
  }
}
